<div fxLayout="column" fxLayoutGap="20px">
  <h1>Gestão de Usuários</h1>

  <div *ngIf="!acessoPermitido" class="acesso-negado">
    <mat-icon class="acesso-negado-icon">lock</mat-icon>
    <h2>Acesso Restrito</h2>
    <p>Somente usuários CTU podem acessar esta funcionalidade.</p>
  </div>

  <ng-container *ngIf="acessoPermitido">

  <div class="filters-row" fxLayout="row wrap" fxLayoutGap="15px" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="filtro-busca">
      <mat-label>Buscar (nome, username, matrícula)</mat-label>
      <input matInput [formControl]="searchFC" (keyup.enter)="filtrar()" aria-label="Buscar por nome, username ou matrícula" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filtro-medio">
      <mat-label>Papel</mat-label>
      <mat-select [formControl]="papelFC" (selectionChange)="filtrar()" aria-label="Filtrar por papel">
        <mat-option *ngFor="let p of papeis" [value]="p.value">{{ p.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filtro-medio">
      <mat-label>Código Unidade</mat-label>
      <input matInput [formControl]="unidadeFC" (keyup.enter)="filtrar()" aria-label="Filtrar por código de unidade" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filtro-medio">
      <mat-label>Sigla Unidade</mat-label>
      <input matInput [formControl]="siglaFC" (keyup.enter)="filtrar()" aria-label="Filtrar por sigla da unidade" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
    <button mat-raised-button color="primary" (click)="filtrar()" aria-label="Aplicar filtros">
      <mat-icon>search</mat-icon> Filtrar
    </button>

    <button mat-stroked-button (click)="limparFiltros()" aria-label="Limpar filtros">
      <mat-icon>clear</mat-icon> Limpar
    </button>

    <span fxFlex></span>

    <button mat-raised-button color="accent" (click)="abrirDialog()" aria-label="Adicionar novo usuário">
      <mat-icon>add</mat-icon> Adicionar
    </button>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)" aria-label="Lista de usuários do sistema">
      <caption class="visually-hidden">Lista de usuários com papéis de gestão</caption>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let u">{{ u.username }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>E-mail</th>
        <td mat-cell *matCellDef="let u">{{ u.email }}</td>
      </ng-container>

      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Matrícula</th>
        <td mat-cell *matCellDef="let u">{{ u.matricula }}</td>
      </ng-container>

      <ng-container matColumnDef="unidade">
        <th mat-header-cell *matHeaderCellDef scope="col">Unidade</th>
        <td mat-cell *matCellDef="let u">{{ getUnidadeNome(u) }}</td>
      </ng-container>

      <ng-container matColumnDef="codigoUnidade">
        <th mat-header-cell *matHeaderCellDef scope="col">Cód. Unidade</th>
        <td mat-cell *matCellDef="let u">{{ u.codigoUnidade }}</td>
      </ng-container>

      <ng-container matColumnDef="papeis">
        <th mat-header-cell *matHeaderCellDef scope="col">Papéis</th>
        <td mat-cell *matCellDef="let u">{{ getPapeisNomes(u) }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col" class="col-acoes">Ações</th>
        <td mat-cell *matCellDef="let u">
          <button mat-icon-button [matMenuTriggerFor]="menuAcoes" [attr.aria-label]="'Ações para ' + u.nome">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuAcoes="matMenu">
            <button mat-menu-item (click)="abrirDialog(u)">
              <mat-icon color="primary">edit</mat-icon>
              <span>Editar dados</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item *ngFor="let p of u.papeis" (click)="removerPapel(u, p.nome)">
              <mat-icon color="warn">person_remove</mat-icon>
              <span>Remover papel {{ p.nome }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="7">
          <app-table-no-data [searchValue]="searchFC.value || ''"></app-table-no-data>
        </td>
      </tr>
    </table>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      (page)="pageChanged($event)"
      aria-label="Paginação da lista de usuários">
    </mat-paginator>
  </div>
  </ng-container>
</div>
